import Headroom from "headroom.js";
import { showBackdrop, hideBackdrop } from '../components/backdrop'
import { throttle } from "../helpers";
import Cookies from 'js-cookie';

(function ($, window) {
    const header = document.querySelector("header.site-header");

    const headroom = new Headroom(header, {
        tolerance: {
            up: 10,
            down: 0
        },
        offset: header.clientHeight,
    });
    headroom.init();

    //////////// MAKING SPACE FOR NAV
    const $promoStrip = $('.announcement-bar');
    const $main = $('main.main-content');

    const makeSpaceForHeader = function () {
        const promoStripHeight = $promoStrip.length ? $promoStrip.outerHeight(true) : 0;

        if ($promoStrip.length > 0) {
            $main.css({ 'margin-top': promoStripHeight });
        }
    }

    $(window).on('resize', throttle(makeSpaceForHeader, 300));
    makeSpaceForHeader();

    //////////// MAKING SPACE FOR NAV

    //////////// NAV HOVER
    const $desktopNav = $('.site-nav__main');
    if ($desktopNav.length) {
        $desktopNav.on('mouseenter', '[data-meganav-level="1"]', showBackdrop);
        $desktopNav.on('mouseleave', '[data-meganav-level="1"]', hideBackdrop);
    }
    //////////// NAV HOVER

    $(window).on('scroll', function () {
        if ($(window).scrollTop() > 5 || $('.search-bar-desktop').hasClass('expanded') || $('#NavDrawer').hasClass('js-drawer-open')) {
            $('.header-bg').addClass('scrolled-page scrolled');
        } else {
            $('.header-bg').removeClass('scrolled-page scrolled');
        }

        const promoStripHeight = $promoStrip.length ? $promoStrip.outerHeight(true) : 0;

        if ($promoStrip.length > 0) {
            if ($('.site-header').hasClass('headroom--unpinned')) {
                $('.main-content').css({ 'margin-top': 0 });
            } else {
                $('.main-content').css({ 'margin-top': promoStripHeight });
            }
        }
    });

    $('#header')
    .on('mouseenter', function () {
        if (!$('html').hasClass('supports-touch') && $(window).scrollTop() < 5) {
            $('.header-bg').addClass('scrolled-page');
        }
    }).on('mouseleave', function () {
        if (!$('html').hasClass('supports-touch') && $(window).scrollTop() < 5) {
            if (!$('.search-bar-desktop').hasClass('expanded')) {
                $('.header-bg').removeClass('scrolled-page');
            }
        }
    });

    $('.js-close-announcement').on('click', function () {
        $('.announcement-bar').addClass('hidden');
        makeSpaceForHeader();
        Cookies.set('announcement', 'hide', { expires: 1 })
    });


function getCookie(name) {
    var allCookies = document.cookie;
    var prefix = name + "=";
    var begin = allCookies.indexOf("; " + prefix);
    if (begin == -1) {
        begin = allCookies.indexOf(prefix);
        if (begin != 0) return null;
    }
    else
    {
        begin += 2;
        var end = document.cookie.indexOf(";", begin);
        if (end == -1) {
        end = allCookies.length;
        }
    }
    return decodeURI(allCookies.substring(begin + prefix.length, end));
} 
    var myCookie = getCookie("announcement");
    if (myCookie == null) {
        $('.announcement-bar').removeClass('hidden');
        makeSpaceForHeader();
    }


    $('.supports-touch .language-selector__wrapper .countries-link').on('click', function () {
        $(this).toggleClass('open');
        $(this).next('.language-selector__content').slideToggle('slow');
    });

    $('.js-drawer-open-button-left').on("click", function () {
        $('.header-bg').addClass('scrolled-page');
    });

    $('[data-search-desktop]').on("click", function () {
        $('.search-bar-desktop').toggleClass('expanded');
        $('.header-bg').addClass('scrolled-page');
    });

    $('[data-search-desktop-close]').on("click", function () {
        $('.search-bar-desktop').removeClass('expanded');
    });

    $('[data-search-mobile]').on("click", function () {
        $('.header-bg').addClass('hide');
    });

    $('[data-search-mobile-close]').on("click", function () {
        $('.header-bg').removeClass('hide');
    });

    $('.show-more-text').on("click", function () {
        $('.seg-description').toggleClass('toggle-description');
        $('.hide-more-text').css('display', 'block');
        $(this).css('display', 'none');
    });

    $('.hide-more-text').on("click", function () {
        $('.seg-description').toggleClass('toggle-description');
        $('.show-more-text').css('display', 'block');
        $(this).css('display', 'none');
    });



})(jQuery, window);
